/**
 * Created by Jerker Nord on 2018-09-27.
 */
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite} from "gsap";
import {IceIceYetiGameAssets} from "../../IceIceYetiGameAssets";
import {IceIceYetiGameConfig} from "../../IceIceYetiGameConfig";
import {IceIceYetiSoundConfig} from "../../IceIceYetiSoundConfig";

export class IceIceYetiBigWinExplosionsController extends BaseView {

    private static FIREWORK_SOUNDS:string[] = [IceIceYetiSoundConfig.instance.FIREWORK_01, IceIceYetiSoundConfig.instance.FIREWORK_02, IceIceYetiSoundConfig.instance.FIREWORK_03];

    private _level01Explosions:TimelineLite[];
    private _level02Explosions:TimelineLite[];
    private _level03Explosions:TimelineLite[];
    private _abortLevel01:boolean = false;
    private _abortLevel02:boolean = false;
    private _abortLevel03:boolean = false;
    private _level01MaximumExplosions:number = 4;
    private _level02MaximumExplosions:number = 7;
    private _level03MaximumExplosions:number = 10;
    private _layer:ScalableLayer;

    constructor() {
        super();
        this._layer = StageManager.getLayer(IceIceYetiGameConfig.instance.LAYERS.BIG_WIN.name);
        this._layer.addChild(this);
    }

    public createAnimations():void {
        this._level01Explosions = this.createExplosions(this._level01MaximumExplosions, GameResources.getTextures(IceIceYetiGameAssets.SMALL_WIN), () => this.onLevel01ExplosionComplete());
        this._level02Explosions = this.createExplosions(this._level02MaximumExplosions, GameResources.getTextures(IceIceYetiGameAssets.MEDIUM_WIN), () => this.onLevel02ExplosionComplete());
        this._level03Explosions = this.createExplosions(this._level03MaximumExplosions, GameResources.getTextures(IceIceYetiGameAssets.LARGE_WIN), () => this.onLevel03ExplosionComplete());
    }

    private onLevel01ExplosionComplete():void {
        if(this._abortLevel01 == false) {
            for(let i:number = 0; i < this._level01Explosions.length; i++) {
                if(this._level01Explosions[i].isActive() == false) {
                    this._level01Explosions[i].restart();
                    break
                }
            }
        }
    }

    private onLevel02ExplosionComplete():void {
        if(this._abortLevel02 == false) {
            for(let i:number = 0; i < this._level02Explosions.length; i++) {
                if(this._level02Explosions[i].isActive() == false) {
                    this._level02Explosions[i].restart();
                    break
                }
            }
        }
    }

    private onLevel03ExplosionComplete():void {
        if(this._abortLevel03 == false) {
            for(let i:number = 0; i < this._level03Explosions.length; i++) {
                if(this._level03Explosions[i].isActive() == false) {
                    this._level03Explosions[i].restart();
                    break
                }
            }
        }
    }

    private createExplosions(amount:number, textures:PIXI.Texture[], onComplete:Function):TimelineLite[] {
        let explosions:TimelineLite[] = [];
        for(let i:number = 0; i < amount; i++) {
            let tl:TimelineLite = new TimelineLite({onComplete : onComplete, paused : true});
            let tempAnimation:TimelineSprite = new TimelineSprite(textures);
            tempAnimation.show();
            tempAnimation.visible = false;
            tempAnimation.blendMode = PIXI.BLEND_MODES.ADD;
            this.addChild(tempAnimation);
            tl.add(() => tempAnimation.position = this.randomizeExplosionPosition());
            tl.add(() => tempAnimation.visible = true, this.getRandomDelay());
            tl.add([
                tempAnimation.getAnimation(),
                (() => this.playSoundEffect())
            ]);
            tl.add(() => tempAnimation.visible = false);
            explosions.push(tl);
        }
        return explosions;
    }

    private playSoundEffect():void {
        if(this.visible == true) {
            SlotGame.sound.playEffect(IceIceYetiBigWinExplosionsController.FIREWORK_SOUNDS[MathHelper.randomIntInRange(0, 2)]);
        }
    }

    private playLevel01Explosion():void {
        let tempAnimation:TimelineLite;
        for(let i:number = 0; i < this._level01Explosions.length; i++) {
            tempAnimation = this._level01Explosions[i];
            tempAnimation.restart();
        }
    }

    private playLevel02Explosion():void {
        let tempAnimation:TimelineLite;
        for(let i:number = 0; i < this._level02Explosions.length; i++) {
            tempAnimation = this._level02Explosions[i];
            tempAnimation.restart();
        }
    }

    private playLevel03Explosion():void {
        let tempAnimation:TimelineLite;
        for(let i:number = 0; i < this._level03Explosions.length; i++) {
            tempAnimation = this._level03Explosions[i];
            tempAnimation.restart();
        }
    }

    private getRandomDelay():string {
        return "+=" + MathHelper.randomIntInRange(0.2, 6);
    }

    private randomizeExplosionPosition():PIXI.Point {
        let xPos:number;
        let yPos:number;
        //Limit X or Y
        if(MathHelper.randomIntInRange(0, 1) > 0) {
            xPos = MathHelper.randomIntInRange(300, 700);
            //Limit Y
            if(MathHelper.randomIntInRange(0, 1) > 0) {
                yPos = MathHelper.randomIntInRange(0, 20);
            } else {
                yPos = MathHelper.randomIntInRange(280, 300);
            }

        } else {
            yPos = MathHelper.randomIntInRange(0, 300);
            //Limit x
            if(MathHelper.randomIntInRange(0, 1) > 0) {
                xPos = MathHelper.randomIntInRange(300, 350);
            } else {
                xPos = MathHelper.randomIntInRange(650, 700);
            }
        }

        //let xPos:number = MathHelper.randomIntInRange(300, 700);
        //let yPos:number = MathHelper.randomIntInRange(0, 300);
        return new PIXI.Point(xPos, yPos);
    }

    public playExplosions(winType:WinRatioType):void {
        if(winType == WinRatioType.SUPER_MEGA_WIN) {
            this._abortLevel02 = true;
            this.playLevel03Explosion();
        } else if(winType == WinRatioType.MEGA_WIN) {
            this._abortLevel01 = true;
            this.playLevel02Explosion();
        } else {
            this.visible = true;
            this.playLevel01Explosion();
            this._abortLevel01 = false;
            this._abortLevel02 = false;
            this._abortLevel03 = false;
        }
    }

    public abortExplosions():void {
        this.visible = false;
        this._abortLevel01 = true;
        this._abortLevel02 = true;
        this._abortLevel03 = true;
    }
}